import React from 'react'
import LandingPage from '../components/LandingPage'
import Partners from '../components/Partners'
import WhoWeAre from '../components/WhoWeAre'
import WhatWeDo from '../components/WhatWeDo'
import Testimonials from '../components/Testimonial'
import Call from '../components/Call'
import Footer from '../components/Footer'
import Mission from '../components/Mission'

function Home() {
  return (
    <div>
        <LandingPage/>
        <Partners/>
        <WhoWeAre/>
        <Mission/>
        <WhatWeDo/>
        <Testimonials/>
        <Call/>
        <Footer/>
    </div>
  )
}

export default Home